<template>
  <div class="root flex justify-between items-center">
    <p v-bind:style="{height:height}" class="w-full">
      <slot />
    </p>
    <slot name="icon" />
  </div>

</template>

<script>
export default {
  name: "MsTextBorder",
  props: {
    height: {
      type: String,
      default: "35px"
    }
  },
  data() {
    return {
      isEdit: false
    };
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.root {
  width: 100%;
  border-bottom: 1px solid #e3e5ee;
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mi-pencil {
    opacity: 0;
  }
  &:hover {
    .mi-pencil {
      opacity: 1;
    }
  }
}
</style>
